export const profileName = 'rohit';
export const profileSurname = 'rana';
export const resumeUrlName = 'assets/pdf/Rohit_Rana_JFSD_CV25.pdf';
export const userEmail = 'rohit.rana0207@gmail.com';

export const hLink = {
  gitHubLink: 'https://www.github.com/rohitrana7/',
  linkedinLink: 'https://www.linkedin.com/in/rohitrana7/',
  facebookLink: 'https://www.facebook.com/rohitranalife/',
  twitterLink: 'https://x.com/im_rohitrana/',
  instagramLink: 'https://www.instagram.com/imrohit.rana/',
  hackerRankLink: 'https://www.hackerrank.com/rohitrana7/',
  stackOverflowLink: 'https://stackoverflow.com/users/10141967/enthucoder',
};
